<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-4">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>GPS Settings</h3>
      </div>
      <v-container>
        <v-row>
          <v-col cols="12" sm="2">System Type: </v-col>
          <v-col cols="12" sm="10">
            <v-select
              outlined
              hide-details
              dense
              v-model="selectedgpssystem"
              placeholder="Select System"
              :items="gpsSystems"
              @change="onGPSSystemChanged($event)">
            </v-select>
          </v-col>
          <v-col cols="12">
            <p style="padding-left: 8px; color: red; padding-top: 10px">
              Please input the coordinates of the same point in both Site and 3D model
            </p>
          </v-col>

          <v-col cols="12" sm="2"><div>UTM Site Point (N,E):</div> </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              type="number"
              outlined
              dense
              v-virtual-keyboard
              name="gpsOriginN"
              label="Site Point North (N)"
              v-model="forgesettings.gpsSettings.originN"
              placeholder="Site Point North (N)"></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              type="number"
              v-virtual-keyboard
              outlined
              dense
              name="gpsOriginN"
              label="Site Point East (E)"
              v-model="forgesettings.gpsSettings.originE"
              placeholder="Site Point East (E)"></v-text-field
          ></v-col>
          <v-col cols="12" sm="2">Model 3D Point (X,Y): </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              type="number"
              outlined
              dense
              v-virtual-keyboard
              name="modelX"
              v-model="forgesettings.gpsSettings.x"
              placeholder="Model 3D Point (X)"
              label="Model 3D Point (X)"
          /></v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              type="number"
              outlined
              dense
              v-virtual-keyboard
              name="modelY"
              v-model="forgesettings.gpsSettings.y"
              placeholder="Model 3D Point (Y)"
              label="Model 3D Point (Y)"
          /></v-col>

          <v-col cols="12" sm="2">Site Angle(Degree)</v-col>
          <v-col cols="12" sm="10">
            <v-text-field
              type="number"
              outlined
              dense
              v-virtual-keyboard
              name="angle"
              v-model="forgesettings.gpsSettings.angle"
              placeholder="Site Angle (Degree)"
              label="Site Angle (Degree)"
          /></v-col>
          <v-col cols="12" class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings()" v-has="permissions.GPSSettings.Access"
              >Save</v-btn
            >
            <!-- will add Permission here  -->
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { toggleExpandComponent } from '../../../scripts/js/forgeviewer';
  import permissions from '@Share/config/permissions';

  export default {
    name: 'AdminSettings',
    props: ['assetid'],
    data() {
      return {
        isExpanded: false,
        gpsSystems: this.$store.state.forgeService.gpsSystems,
        permissions,
      };
    },
    methods: {
      onGPSSystemChanged($event) {
        this.forgesettings.gpsSettings.isIndianSystem =
          this.gpsSystems.indexOf($event.target.value) == 1;
      },
      saveSettings() {
        if (!parseFloat(this.forgesettings.gpsSettings.angle.toString())) {
          this.$dialog.notify.warning('Angle is not filled correctly.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (!parseFloat(this.forgesettings.gpsSettings.originE.toString())) {
          this.$dialog.notify.warning('Origin E is not filled correctly.', {
            position: 'top-right',
            timeout: 3000,
          });

          return;
        }
        if (!parseFloat(this.forgesettings.gpsSettings.originN.toString())) {
          this.$dialog.notify.warning('Origin N is not filled correctly.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (!parseFloat(this.forgesettings.gpsSettings.x.toString())) {
          this.$dialog.notify.warning('Point 3D X is not filled correctly.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        if (!parseFloat(this.forgesettings.gpsSettings.y.toString())) {
          this.$dialog.notify.warning('Point 3D Y is not filled correctly.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.forgeService.saveSettings(this.assetid, this.forgesettings, () => {
          this.$dialog.notify.success('GPS Settings saved successfully.', {
            position: 'top-right',
            timeout: 3000,
          });
        });
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
    },
    computed: {
      forgesettings() {
        return this.$store.state.forgeSettings;
      },
      selectedgpssystem: {
        get() {
          if (this.forgesettings.gpsSettings.isIndianSystem) return this.forgeService.gpsSystems[1];
          return this.forgeService.gpsSystems[0];
        },
        set(val) {
          this.forgesettings.gpsSettings.isIndianSystem = this.forgeService.gpsSystems[1] == val;
        },
      },
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
    },
  };
</script>

<style>
  .gps-menu {
    flex-grow: 1;
    cursor: pointer;
  }
</style>
